import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, RouterModule } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { TabsModule } from 'primeng/tabs';

interface IReviewTab {
    label: string,
    routerLink: string,
    icon?: string,
    img?: string,
}

@Component({
    selector: 'app-review-tabs',
    imports: [
        RouterOutlet, RouterModule, TabsModule, CommonModule
    ],
    standalone: true,
    providers: [
        ConfirmationService
    ],
    templateUrl: './review-tabs.component.html',
    styleUrl: './review-tabs.component.scss'
})

export class ReviewTabsComponent implements OnInit {
    TABS_KEYS = {
        REVIEW: 'REVIEW',
        DUPLICATE: 'DUPLICATE',
    }
    TABS: { [key: string]: IReviewTab } = {
        [this.TABS_KEYS.REVIEW]: {
            label: 'Review List',
            routerLink: 'review-qna',
            icon: 'pi pi-list-check',
        },
        [this.TABS_KEYS.DUPLICATE]: {
            label: 'Duplicate Q&A',
            routerLink: 'review-duplicate',
            icon: 'pi pi-copy',
        }
    }
    tabs: IReviewTab[] = [];
    constructor(
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.tabs = [
            this.TABS[this.TABS_KEYS.REVIEW],
            this.TABS[this.TABS_KEYS.DUPLICATE]
        ];
    }

    goBack() {
        this.router.navigate(['/settings/innform/qa-pair']);
    }

    isActive(routerLink: string): boolean {
        return this.router.url.includes(routerLink);
    }

    getActiveTabValue(): string {
        const currentUrl = this.router.url;
        const tabIndex = this.tabs.findIndex(tab => currentUrl.includes(tab.routerLink));
        return tabIndex >= 0 ? tabIndex.toString() : '0';
    }
} 